// src/components/Home.js
import React from "react";
import "./Home.css"; // We'll create this for styling
import banner_image from "../../assets/banner_image.jpg";
import banner_image_mobile from "../../assets/banner_image_mobile.jpg";

const Home = () => {
  return (
    <div className="home-container">
      <img className="image-desktop" src={banner_image} alt="Desktop view" />
      <img className="image-tablet" src={banner_image} alt="Tablet view" />
      <img
        className="image-mobile"
        src={banner_image_mobile}
        alt="Mobile view"
      />
      <div className="overlay">
        <div className="content">
          <h1>Discover Your Ideal Home or Business Space with Us!</h1>
          <p>
            Divine Realty guides you to your perfect home or commercial space,
            ensuring a seamless and tailored experience throughout your real
            estate journey.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
